import { LocalNotifications } from "@capacitor/local-notifications";

const setupNotificationsChannel = async () => {
  try {
    await LocalNotifications.createChannel({
      id: "task_notifications",
      name: "Mindstack",
      importance: 5, // Ensures high-priority notifications
      vibration: true, // Enables vibration
    });

    await LocalNotifications.createChannel({
      id: "engagement_notifications",
      name: "Daily Reminders",
      importance: 3, // Default importance — visible but not intrusive
      vibration: false,
    });
  } catch (error) {
    console.warn("Failed to setup notifications channel:", error.message);
  }
};

export default setupNotificationsChannel;
